import "./index.css";
import { useContext, useState } from "react";
import { UserContext } from "../../../../../../App";
import { useSelector } from "react-redux";
import { getMobilePos } from "../../../all-products/redux/Reducers/paginationReducer";
import { emit } from "react-native-react-bridge/lib/web";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import Navbar from "../../../../posnavbar/Navbar";
import { useNavigate } from "react-router-dom";

const ThemeCard = ({ mode, title, description, currMode, changeMode, changeColorFun, disabled, onDisabledClick }) => {
  const isActive = currMode === mode?.toLowerCase();

  return (
    <button
      type="button"
      className={`theme-card ${isActive ? "theme-card-active" : "theme-card-inactive"} ${disabled ? "theme-card-disabled" : ""}`}
      data-testid={`button-theme-${mode?.toLowerCase()}`}
      onClick={() => {
        if (disabled) {
          onDisabledClick && onDisabledClick();
          return;
        }
        changeMode(mode?.toLowerCase());
        changeColorFun(mode?.toLowerCase());
      }}
    >
      <div className="theme-card-header">
        {mode === "Light" ? (
          <div className="theme-card-icon-wrapper light-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-sun"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="4"></circle>
              <path d="M12 2v2"></path>
              <path d="M12 20v2"></path>
              <path d="m4.93 4.93 1.41 1.41"></path>
              <path d="m17.66 17.66 1.41 1.41"></path>
              <path d="M2 12h2"></path>
              <path d="M20 12h2"></path>
              <path d="m6.34 17.66-1.41 1.41"></path>
              <path d="m19.07 4.93-1.41 1.41"></path>
            </svg>
          </div>
        ) : (
          <div className="theme-card-icon-wrapper dark-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-moon"
              aria-hidden="true"
            >
              <path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401"></path>
            </svg>
          </div>
        )}

        {isActive && (
          <div className="theme-card-check-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-check"
              aria-hidden="true"
            >
              <path d="M20 6 9 17l-5-5"></path>
            </svg>
          </div>
        )}
      </div>

      <div className="theme-card-content">
        <p className="theme-card-title">{title}</p>
        <p className="theme-card-description">{description}</p>
      </div>

      <div
        className={`theme-card-preview-container ${
          mode === "Light" ? "light-preview" : "dark-preview"
        }`}
      >
        <div className="theme-preview-dots-row">
          <div className="theme-preview-dot"></div>
          <div className="theme-preview-line-short"></div>
        </div>
        <div className="theme-preview-grid">
          <div className="theme-preview-grid-left">
            <div className="theme-preview-line-medium"></div>
            <div className="theme-preview-box-large"></div>
          </div>
          <div className="theme-preview-grid-right">
            <div className="theme-preview-line-tiny"></div>
            <div className="theme-preview-box-small"></div>
            <div className="theme-preview-box-small"></div>
          </div>
        </div>
      </div>
    </button>
  );
};

const ChangeTheme = () => {
  const navigate = useNavigate();
  const { color, setColor } = useContext(UserContext);
  const [themeVal, setThemeVal] = useState(color);

  const isMobilePos = useSelector(getMobilePos);
  const retailType = localStorage.getItem("retailType");
  const showSnackbar = useSnackbar();

  // change theme
  const changeColorFun = (chooseThemeVal) => {
    if (chooseThemeVal === "light") {
      setColor("light");
      localStorage.setItem("color", "light");
      isMobilePos &&
        emit({
          type: "localData",
          data: {
            color: "light",
          },
        });
      document.body.classList.remove("dark");
    } else {
      setColor("dark");
      localStorage.setItem("color", "dark");
      isMobilePos &&
        emit({
          type: "localData",
          data: {
            color: "dark",
          },
        });
      document.body.classList.add("dark");
    }
  };

  return (
    <Navbar>
      <div className="theme-outer-par">
        <div className="theme-sticky-header">
          <div className="theme-header-content">
            <div className="theme-header-left">
              <button
                type="button"
                className="theme-back-button"
                data-testid="button-theme-back"
                onClick={() => navigate(`/products/operations-menu`)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-arrow-left"
                  aria-hidden="true"
                >
                  <path d="m12 19-7-7 7-7"></path>
                  <path d="M19 12H5"></path>
                </svg>
              </button>
              <h1 className="theme-header-title">Theme Settings</h1>
            </div>
          </div>
        </div>

        <div className="theme-main-content">
          <div className="theme-settings-card">
            <div className="theme-appearance-section">
              <div>
                <h2 className="theme-card-heading">Appearance</h2>
                <p className="theme-card-subheading">
                  Dark mode now applies directly across the app. System mode and accent color
                  options have been removed.
                </p>
              </div>
              <div className="theme-active-badge" data-testid="text-theme-current-mode">
                <span className="active-badge-label">Active:</span>
                <span className="active-badge-value">{themeVal?.charAt(0).toUpperCase() + themeVal?.slice(1)}</span>
              </div>
            </div>

            <div className="theme-cards-grid">
              <ThemeCard
                mode={"Light"}
                title={"Light"}
                description={"Clean, bright surfaces for daytime billing and floor use."}
                currMode={themeVal}
                changeMode={setThemeVal}
                changeColorFun={changeColorFun}
              />

              <ThemeCard
                mode={"Dark"}
                title={"Dark"}
                description={"Low-glare dark workspace for evening counters and focused operation."}
                currMode={themeVal}
                changeMode={setThemeVal}
                changeColorFun={changeColorFun}
              />
            </div>
          </div>
        </div>
      </div>
    </Navbar>
  );
};

export default ChangeTheme;
